var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none",
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#475467",
    fillRule: "evenodd",
    d: "M.875 7a6.125 6.125 0 1 0 12.25 0A6.125 6.125 0 0 0 .875 7ZM14 7A7 7 0 1 1 0 7a7 7 0 0 1 14 0ZM3.937 6.562a.438.438 0 0 0 0 .875h5.07l-1.88 1.879a.438.438 0 0 0 .619.618l2.625-2.625a.438.438 0 0 0 0-.618L7.747 4.066a.438.438 0 0 0-.619.618l1.878 1.878H3.937Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightCircle);
export default __webpack_public_path__ + "static/media/arrow-right-circle.9267a82f58a6f192a4752a6d20907181.svg";
export { ForwardRef as ReactComponent };